var map = {
	"./drdoctor/img/icons/new_health_tips_icon.png": 632,
	"./freedoctor/img/icons/new_health_tips_icon.png": 633,
	"./freelegal/img/icons/new_health_tips_icon.png": 634,
	"./legalchief/img/icons/new_health_tips_icon.png": 635,
	"./medi4u/img/icons/new_health_tips_icon.png": 636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 199;